<template>
  <div>
    <div id="AUV" class="w-100 eliptical-gray">
      <br />
      <br />
      <h2 class="back-text">OUR AUV</h2>
      <h1 style="font-weight: bold; color: #00264a;">SWIFT</h1>
      <br />
      <br />
      <br />
      <b-container fluid="lg">
        <b-row>
          <b-col sm="6">
            <div style="width: 100%; margin: auto; align-content: center; display: flex;">
              <b-img-lazy
                style="margin: auto; width: 80%; min-width: 300px"
                src="../../public/img/auv/auv/auv.png"
                alt="SWIFT"
              ></b-img-lazy>
            </div>
          </b-col>
          <b-col sm="6">
            <div
              style="display: flex; justify-content: space-around; flex-wrap: wrap; width: 100%;"
            >
              <div v-for="section in sections" :key="section.id" class="team-section">
                <a style="color: #00264a;" :href="section.href" class="row">
                  <b-img-lazy class="col" style="width: 100%;" :src="section.icon"></b-img-lazy>
                  <h5 class="col">{{section.name}}</h5>
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <br />
    </div>

    <b-container id="General">
      <b-row
        sm
        v-for="specs in auv_specs"
        :key="specs.id"
        class="fade-in auv-specs"
        :class="'auv-specs-' + specs.position"
      >
        <b-col class="vdrax-big-image" sm :order="specs.positionOrder1">
          <b-img-lazy :src="specs.imgSrc" alt="V-Drax" :class="'vdrax-img-' + specs.position"></b-img-lazy>
        </b-col>
        <b-col v-if="!specs.tables" :order="specs.positionOrder2" class="v-drax-specs-content">
          <b-row cols="2">
            <b-col sm="6" v-for="spec in specs.specs" :key="spec.id">
              <b-list-group>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar
                    style="min-width:40px; width: 70px;"
                    square
                    variant="info"
                    :src="spec.logoSrc"
                    class="mr-3"
                  ></b-avatar>
                  <b-badge size="8em" variant="primary" class="mr-2">{{spec.number}}</b-badge>
                  <span class="mr-auto">{{spec.name}}</span>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="specs.tables" :order="specs.positionOrder2" class="v-drax-specs-content">
          <div v-for="table in specs.tables" :key="table.id">
            <hr />
            <h3 class="table-caption">{{table.caption}}</h3>
            <b-table
              small
              table-variant="secondary"
              outlined
              :items="table.data"
              stacked
              caption-top
            ></b-table>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div v-for="tech in techDetails" :key="tech.id" :class="tech.class" :id="tech.name">
      <h2 class="back-text">technicality</h2>
      <h3 style="font-weight: bold;">{{tech.name}} Part</h3>
      <div class="breaker"></div>
      <br />
      <h5 style="width: 70%; margin: auto;">{{tech.text}}</h5>
      <br />
      <br />
      <br />
      <div class="technicalities-container">
        <div v-for="header in tech.headers" :key="header.id">
          <div>
            <h3 class="tech-header">{{header.name}}</h3>
            <h5>{{header.text}}</h5>
          </div>

          <div class="row">
            <b-carousel
              v-if="header.images.length"
              indicators
              :controls="(header.images.length > 1)? true : false"
              :interval="2000"
              class="carousel-auv"
            >
              <b-carousel-slide
                v-for="img in header.images"
                :key="img.id"
                :img-src="img.src"
                v-b-modal=" 'picture' + tech.id + '_' + header.id + '_' + img.id"
                style="width: 100%; max-height: 400px;"
                :caption="img.name"
                :caption-tag="'h5'"
              >
                <b-modal
                  :id=" 'picture' + tech.id + '_' + header.id + '_' + img.id"
                  size="lg"
                  ok-only
                  :title="img.name"
                >
                  <b-img-lazy class="w-100" :src="img.src"></b-img-lazy>
                </b-modal>
              </b-carousel-slide>
            </b-carousel>
            <div v-if="header.haveTable" class="col content-table">
              <b-table
                :caption="header.tableTitle"
                caption-top
                responsive
                striped
                hover
                :items="header.contentTable"
                :fields="header.fields"
              ></b-table>
            </div>
            <div v-if="header.videos">
              <iframe
                v-for="video in header.videos"
                :key="video.id"
                class="col"
                :src="video"
                width="640"
                height="480"
                allow="autoplay"
              ></iframe>
            </div>
          </div>
          <br />

          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.tech-header {
  color: #00264a;
  font-weight: bold;
}

.team-section {
  display: inline-block;
  max-width: 150px;
  cursor: pointer;
  transition: 0.2s all ease-in-out !important;
}

.team-section:hover {
  transform: scale(1.1);
}

.technicalities-container {
  width: 70%;
  margin: auto;
  text-align: left;
}

.tech-header-img {
  width: 100%;
  min-width: 200px;
  cursor: pointer;
  max-width: 400px;
}

.carousel-auv {
  box-shadow: 0 0px 10px 5px rgba(0, 0, 0, 0.3);
  width: 50%;
  min-width: 300px;
  max-width: 600px;
  margin: auto;
}

.technicalities-container .carousel-control-next {
  background-color: rgba(0, 0, 0, 0.2);
}

.technicalities-container .carousel-control-prev {
  background-color: rgba(0, 0, 0, 0.2);
}

.carousel-caption {
  top: -10px !important;
  color: #00264a !important;
}

.carousel-caption h5 {
  background-color: rgba(255, 255, 255, 0.7);
}
</style>

<script>
export default {
  data() {
    return {
      show: false,
      sections: [
        {
          id: 0,
          name: "General Specs",
          icon: "img/auv/auv/icons/general.png",
          href: "#General"
        },
        {
          id: 1,
          name: "Mechanical",
          icon: "img/auv/auv/icons/mechanical.png",
          href: "#Mechanical"
        },
        {
          id: 2,
          name: "Electrical",
          icon: "img/auv/auv/icons/electrical.png",
          href: "#Electrical"
        },
        {
          id: 3,
          name: "Software",
          icon: "img/auv/auv/icons/software.png",
          href: "#Software"
        },
        {
          id: 4,
          name: "Localization",
          icon: "img/auv/auv/icons/localization.png",
          href: "#Localization"
        }
      ],
      techDetails: [
        {
          id: 0,
          class: "eliptical-gray",
          name: "Mechanical",
          text:
            "Swift is a smart autonomous underwater vehicle,  it's very special by its modularity , flexibility and streamlined body. Swift is generally designed to have six degrees of freedom of movements using 8 thrusters configuration, and it can dive to a depth of 70 meters down It's small , it's light and easy to handle.",
          headers: [
            {
              id: 0,
              name: "Internal structure and frame",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/internal_structure.png",
                  name: "Internal Structure"
                },
                {
                  id: 1,
                  src: "img/auv/auv/cover.png",
                  name: "Streamlined Cover."
                }
              ],
              text:
                "Previously, “as ROVs makers” we used to use an artelon cylindrical tube with two flanges made by Polyamide nylon 6 as a sealed enclosure,  but now, as the modularity was our strategy of work while building the AUV, we had to use many enclosures to make our system as modular as we can, and for reducing the wasted areas in the cylinders and reducing the volume and the buoyancy of the vehicle,  we decided to change the cylindrical enclosure by rectangular ones that made of aluminum. The enclosures were manufactured by a CNC router machine and they were designed and tested to withstand a pressure of up to 70 meters of water. all the enclosures are connected with plug and play connectors and fixed on both sides of an aluminum sheet, the enclosures on one side are fixed back to back to the enclosures on the other side to make it easier to access each enclosure directly. The whole internal structure is covered by a fiber streamlined cover that reduces the drag force on the AUV to be as low as possible, and the cover was also manufactured by a CNC router machine."
            },
            {
              id: 1,
              name: "Droppers",
              images: [
                { id: 0, src: "img/auv/auv/dropper.png", name: "Dropper" },
                {
                  id: 1,
                  src: "img/auv/auv/dropper_in.png",
                  name: "Dropper (inside)"
                }
              ],
              text:
                "The dropper mechanism is very simple, it's designed as a half-circular box with two dropping holes in the bottom, two loading holes at the top, and guiding arms inside. When we insert the markers from the loading holes they will be held by the guiding Arms. These Arms are connected to a servo motor that will force them to move the markers sliding down the dropping holes as each direction of rotation of the servo motor will drop only one marker."
            },
            {
              id: 2,
              name: "Torpedoes",
              images: [
                { id: 0, src: "img/auv/auv/torpedo.png", name: "Torpedo" },
                {
                  id: 1,
                  src: "img/auv/auv/torpedo_in.png",
                  name: "Torpedo (inside)"
                }
              ],
              text:
                "The torpedo launcher consists of a scotch yoke mechanism with double Arms connected to a servo motor, These arms fit in the torpedo back holes. The torpedoes are 3D printed, they were designed and tested to reduce the drag force to the minimum. In the start position these torpedoes will be loaded by compressing the springs behind them, and they will stay still at this position held by the Scots Yorke Arms, then when we turn the servo motor in the clockwise direction the scotch yoke arm will slide out of the torpedo releasing the spring and the torpedo, and for the anticlockwise direction, the other arm will release the other one."
            }
          ]
        },
        {
          id: 1,
          class: "",
          name: "Electrical",
          text:
            "Our Electrical Team was mainly responsible for delivering a flexible and maintainable internal system, So that it’s easy for debugging and troubleshooting. Also to get the most enduring Electrical system and to achieve this, a lot of testing was performed to get the highest possible current rating in SWIFT’s PCBs and so all of our PCBs were designed by our Electrical team to withstand high current taking size in consideration. Another responsibility that lies on the electrical team is to solve the problem of heating inside enclosures and also to apply safety and protection measures while creating the most compact internal design possible.",
          headers: [
            {
              id: 0,
              name: "Internal System",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/wiring_diagram.png",
                  name: "Example for wiring table."
                },
                { id: 1, src: "img/auv/auv/communication.png", name: "CAN Bus" }
              ],
              text:
                "we divided our electrical system into smaller sub-systems, and to connect all of these subsystems without any errors we  created a wiring table that states the connections between every enclosure and it’s a demo for a wiring diagram that represents the whole electrical system of SWIFT. As for communication between these enclosures we used CAN Bus protocol to connect: Nvidia AGX, BMS, Localization, PayLoads. Exception is the pixhawk controller in the propulsion E-pod as it’s connected to the Nvidia through serial communication via USB. ",
              fields: ["Number", "Name"],
              haveTable: true,
              tableTitle: "Our Smaller Sub-Systems",
              contentTable: [
                { Number: 1, Name: "Propulsion", Content: "ESCs, PixHawk" },
                {
                  Number: 2,
                  Name: "Battery Management System ",
                  Content: "Battery, STM32"
                },
                { Number: 3, Name: "Main Computer", Content: "Nvidia AGX" },
                { Number: 4, Name: "Tether/Battery", Content: "" },
                {
                  Number: 5,
                  Name: "Localization",
                  Content: "MC. for acoustic localization."
                },
                {
                  Number: 6,
                  Name: "Cameras",
                  Content: "ZED2, Low Light Camera"
                },
                { Number: 7, Name: "LEDs", Content: "High Luminous Leds" }
              ]
            },
            {
              id: 1,
              name: "PCBs",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/pcb1.png",
                  name: "Propulsion PCB Schematic."
                },
                {
                  id: 1,
                  src: "img/auv/auv/pcb2.png",
                  name: "Manufactured Propulsion PCB in Propulsion Enclosure."
                },
                {
                  id: 2,
                  src: "img/auv/auv/pcb3.png",
                  name: "Attached small fans to heat sinks in each MOSFET"
                },
                {
                  id: 3,
                  src: "img/auv/auv/pcb4.png",
                  name: "Battery M.S. PCB schematic."
                },
                {
                  id: 4,
                  src: "img/auv/auv/pcb5.png",
                  name: "Manufactured Battery M.S. PCB."
                }
              ],
              text:
                "All of SWIFT’s PCBs were designed by the Electrical Team to endure high current while making it as small as possible. SWIFT’s consists of 6 customized PCBs and the trace size for high current traces is 6mm width and 120 microns thickness. Taking into consideration overcurrent failure, Current sensors and fuses were mounted on some of our PCBs. And to solve the problem of high temperatures in MOSFETs we attached small fans to heat sinks in each MOSFET to provide cooling and continuous air Circulation."
            },
            {
              id: 2,
              name: "Battery",
              images: [],
              text:
                "One of SWIFT’s main features that it’s Tetherable, Which means that while testing mode, SWIFT’s Power source is an external power supply through a tether cable and the other mode is the battery powered mode. This allows us to test the whole functionality in spite of the Battery condition and to also increase the Battery life. The switching between the 2 modes is done via a high power Relay. Another feature is that it’s not required to manually charge the battery! A microcontroller is responsible for detecting the battery level and to send a signal to the battery charger to charge the battery and when it is fully charged the charger stops charging the battery. "
            },
            {
              id: 3,
              name: "Testing",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/testing1.png",
                  name: "Copper Trace Testing (Destructive Test)"
                },
                {
                  id: 1,
                  src: "img/auv/auv/testing2.png",
                  name: "Burnt and melted traces after the test."
                }
              ],
              videos: [
                "https://drive.google.com/file/d/14UyZrALNRINwonV-h_cmaML8RVhVhjK2/preview"
              ],
              text:
                "While Designing on SWIFTs Internal system we performed all kinds of testing before the implementation phase for each subsystem to get the most enduring electrical system. Copper Trace Testing (Destructive Test)  → This is a Destructive Test to test the endurance and behavior of a 6mm width copper trace due to high current up to 71.3. At 66.3A the soldering came off due to high temperature but that trace didn’t fail. This test was one of many destructive tests that were performed and as a result of these tests we made our traces 6mm width and 120 microns thick. Servo testing (Components Testing) → We tested all of our components including our payloads to monitor their behaviour in various conditions. PCB Testing (Functionality Testing) → We tested our Prototyped PCBs to monitor their functionality and to match our required trace endurance with the real-life implementation. Relay Testing (Tether Testing) → SWIFT’s Tether mode is switched via a High Power Relay that switches between the battery and an external power supply and so we tested the function of the relay"
            }
          ]
        },
        {
          id: 2,
          class: "eliptical-gray",
          name: "Software",
          text:
            "Our software team applied the V model for the Software Development Life Cycle. Analyzing system Requirements, architecture design ,module design, testing using our simulator. Developed a strong visual prescription module Motion control module and sensor fusion module.",
          headers: [
            {
              id: 0,
              name: "Motion Control",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/graphs.png",
                  name:
                    "Our Reference is in dashed-red, while Actual state is in black"
                }
              ],
              text:
                "We decided to use the Non-linear model predictive control NMPC in SWIFT .  as it’s the most adequate control technique for the trajectory tracking control problem due to its ability to handle both state constraints and actuators constraints which are ubiquitous for the different types of control techniques like the PID, Nonlinear PID and LQR. To design an NMPC-based tracking controller we considered both dynamics and kinematics of  SWIFT, but this comes to the computational complexity of each MPC iteration, to overcome this problem; we had to distribute the optimization problem of the MPC to maneuver and depth sub-problems, this solution is very effective as long as we drive at low-speed due to the coupling between the AUV states. SWIFT’s autopilot consists of the following components as seen in Fig. below:  Waypoints database: Known in advance or generated on the fly by the objects detection system.  Trajectory generator: Converts the discrete set of waypoints to a time-varying continuous function with its higher order derivatives; these derivatives are proportional to the vehicle velocity and acceleration.  Reference model: Uses the generated path parameters and its derivatives along with the AUV state and generates a feasible reference state for the MPC to track.  MPC: receding horizon optimizations, which has the space to solve both the path planning and the trajectory tracking problems. The response of our NMPC controller for tracking a linear x-path and a sinusoidal y-path is shown in the Fig below."
            },
            {
              id: 1,
              name: "Sensor Fusion",
              images: [
                {
                  id: 0,
                  name: "Control and Sensor Fusion Module Diagram",
                  src: "img/auv/auv/sensor_fusion.png"
                }
              ],
              text:
                "Our sensor fusion system is developed based on “the robot localization ROS package”, with adaptations made in the configuration files to extend its use for AUV in 3D space. The EKF algorithm is applied to  minimize the impact of individual sensor failure in determining the current state of SWIFT."
            },
            {
              id: 2,
              name: "Visual preception",
              images: [],
              text:
                "As the AUV's Computer vision algorithms stand in the fore navigation pile, we developed a visual perception module that is divided into four main subsystems: Image enhancement, Object detection, Target analysis & Bias Filtering."
            },
            {
              id: 3,
              name: "Image Enhancement",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/enhancement1.png",
                  name: "Histogram streching"
                },
                {
                  id: 1,
                  src: "img/auv/auv/enhancement2.png",
                  name: "Image Enhancement in action"
                }
              ],
              text:
                "The image enhancement node within the visual perception module utilizes a combination of computer vision algorithms to improve the quality of the raw images, such as flattening the image histogram and cumulative curve, converting the RGB-normalized image to HSV, and applying histogram stretching to the S and V channels before converting back to RGB, as shown in fig below. Another functional component to improve the image enhancement was implementing a GAN model, which is well-trained on hundreds of different underwater image noises and problems and how to fix and enhance the images, as shown in fig below. Then comes the last function that enhances the images, the denoising autoencoder. Through tweaking the image properties, the D-autoencoder model will remove any noises in the raw image, as shown in fig below. With the power of the 3 image enhancement algorithms combined, we can ensure very well that the incoming raw image will be passed to the object detection in its most optimal form, significantly increasing the chance of the object being identified."
            },
            {
              id: 4,
              name: "Object Detection",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/detection1.png",
                  name: "We detected the gate."
                },
                {
                  id: 1,
                  src: "img/auv/auv/detection2.png",
                  name: "We detect the path."
                }
              ],
              text:
                "The object detection node uses the enhanced image to output the detected object’s ID, thresholds, 2D and 3D coordinates, through the Yolov5l model as trained by the team. Example of detections are shown in figs below."
            },
            {
              id: 5,
              name: "Integrating Enhancement & Detection",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/d_and_e1.png",
                  name: "Our Model failed to detect the gate before enhancement"
                },
                {
                  id: 1,
                  src: "img/auv/auv/d_and_e2.png",
                  name:
                    "Our Model succeeded to detect the gate after enhancement"
                }
              ],
              text:
                "The well-trained object detection model alone was not enough for all cases, but the addition of the image enhancement algorithms made possible for successfully detecting the objects under most circumstances. In the fig. below, the object detection only succeeded at detecting the gate when the image enhancement algorithms were applied."
            },
            {
              id: 6,
              name: "Target Analysis",
              images: [],
              text:
                "When the object is successfully detected, the target analysis node takes the enhanced frame and the object data and starts analyzing the region of interest, producing target-specific instructions. For example, the target analysis node can identify the object’s orientation to the AUV, which will help the AUV align itself to the object before approaching it. As shown in fig. below, approaching the gate without the target analysis process would result in the AUV colliding with the gate pipes. The target analysis node identifies the gate’s orientation to the object by considering the lengths of the side pipes and the angle of the horizontal pipe, as well as comparing the distances between the middle and left pipe and the middle and right pipe. This process is done using image processing and k-means clustering. After identifying the orientation, the Local Planner module receives 3D coordinates instructed by the target analysis node to align itself ahead of the object."
            },
            {
              id: 7,
              name: "Bias Filtering",
              images: [],
              text:
                "Before any coordinates are passed to the local planner module, whether of object’s coordinates or the desired point for aligning the AUV to the object, they are first passed to the Bias Filtering node, which filters any biased readings/coordinates, by comparing the current coordinates with the previous coordinates, and checking whether there is a 60% similarity, as if so, the coordinates are confidently passed to the Local Planner module."
            }
          ]
        },
        {
          id: 3,
          class: "",
          name: "Localization",
          text:
            "Attaching a hydrophone to an AUV will add the element of sound to the entire underwater experience, consequently it will detect acoustic targets while navigating, so  our system based on making best use of the sound characteristics so that we made use of the sound intensity decay across distance so we placed the hydrophones as distant as possible so we can get the highest accuracy and most reliable results and based on the Fourier Transform we could gather more information about the signal and with some analysis we could determine the direction of the transmitted sound This functionality achieved",
          headers: [
            {
              id: 0,
              name: "Hydrophones",
              images: [
                {
                  id: 0,
                  src: "img/auv/auv/hydrophones.png",
                  name: "Localization Concept of work"
                }
              ],
              text:
                "by using four distributed hydrophones around the AUV corners with sampling rate of 200kHz simply the algorithm continuously scanning the surroundings and divide it into frames to be processed individually whenever the desired frequency is detected the system calculates the power spectral density and the gathered data is then processed accordingly to determine the highest presence of the signal is at which hydrophone or hydrophones and we select the highest presence of signal happened on which pair of hydrophones then a simple method of localization is to estimate the time delay of arrival (TDOA) of a sound signal between the two microphones. This TDOA estimate is then used to calculate the Angle of Arrival (AoA). Combining the data from two microphone pairs and by using the process of triangulation, we compute the distance of the sound source from the microphone pairs"
            }
          ]
        }
      ],
      accordion_items: [
        {
          id: 1,
          visible: false,
          title: "View SWIFT Enclosures",
          img: "img/auv/auv/enclosures.png",
          contentTitle: "Our AUV is devided internally into this enclosures",
          contentText: "blablablabala",
          fields: ["Number", "Name"],
          showDetails: true,
          contentTable: [
            { Number: 1, Name: "Propulsion", Description: "" },
            { Number: 2, Name: "Battery Management System ", Description: "" },
            { Number: 3, Name: "Nvidia", Description: "" },
            { Number: 4, Name: "Tether/Battery", Description: "" },
            { Number: 5, Name: "Localization", Description: "" },
            { Number: 6, Name: "Camera", Description: "" },
            { Number: 7, Name: "LEDs", Description: "" }
          ]
        },
        {
          id: 2,
          visible: false,
          title: "View Internal Structure",
          img: "img/auv/auv/internal_structure.png",
          contentTitle: "Our Major components are",
          contentText: "blablablabala",
          fields: ["Name", "Supplier"],
          showDetails: true,
          contentTable: [
            { number: 1, Name: "ZED-2", Supplier: "Stereolabs" },
            { number: 2, Name: "DVL", Supplier: "Water Linked" },
            { number: 3, Name: "Jetson Xavier AGX", Supplier: "Nvidia" },
            { number: 4, Name: "PixHawk", Supplier: "Pixhawk" },
            { number: 5, Name: "T-200 Thrusters", Supplier: "Blue Robotics" },
            { number: 6, Name: "Ping 360 Sonar", Supplier: "Blue Robotics" }
          ]
        },
        {
          id: 3,
          visible: false,
          title: "Missions Tools (Torpedo)",
          showDetails: false,
          showInside: true,
          insideImg: "img/auv/auv/torpedo_in.png",
          img: "img/auv/auv/torpedo.png",
          contentTitle: "Torpedo",
          contentText: "blablablabala"
        },
        {
          id: 4,
          visible: false,
          showDetails: false,
          showInside: true,
          insideImg: "img/auv/auv/dropper_in.png",
          title: "Mission Tools (Dropper)",
          img: "img/auv/auv/dropper.png",
          contentTitle: "Mission Tools (Dropper)",
          contentText: "blablablabala"
        },
        {
          id: 5,
          visible: false,
          showDetails: false,
          title: "View SWIFT Frame",
          img: "img/auv/auv/cover.png",
          contentTitle: "Our Cover",
          contentText: "blablablabala"
        }
      ],
      auv_specs: [
        {
          id: 0,
          imgSrc: "img/auv/auv/front.png",
          keyImageSrc: "",
          header: "",
          specs: [
            {
              name: "Thrusters",
              number: 8,
              logoSrc: "img/icons/specs/thruster.png"
            },
            {
              name: "HD Camera",
              logoSrc: "img/icons/specs/camera.png"
            },
            {
              name: "Stereo Camera",
              logoSrc: "img/icons/specs/stereo-camera.png"
            },
            {
              name: "Acoustic Sonar",
              logoSrc: "img/icons/specs/sonar.png"
            },
            {
              name: "Depth hold",
              logoSrc: "img/icons/specs/dh.png"
            },
            {
              name: "Auto Heading",
              logoSrc: "img/icons/specs/ah.png"
            }
          ],
          positionOrder1: "1",
          positionOrder2: "2",
          position: "left"
        },
        {
          id: 1,
          imgSrc: "img/auv/auv/side_small.png",
          keyImageSrc: "",
          header: "",
          specs: [
            {
              name: "High Reliability",
              logoSrc: "img/icons/specs/reliability.png"
            },
            {
              name: "Experienced Team",
              logoSrc: "img/icons/specs/crew.png"
            },
            {
              name: "Easy Maintenance",
              logoSrc: "img/icons/specs/maintenance.png"
            },
            {
              name: "Elegant Design",
              logoSrc: "img/icons/specs/design.png"
            },
            {
              name: "Dynamic Adj. Buoyancy",
              logoSrc: "img/icons/specs/buoyancy.png"
            },
            {
              name: "Manipulators Addition",
              logoSrc: "img/icons/specs/manipulators.png"
            },
            {
              name: "Wide Range of View",
              logoSrc: "img/icons/specs/wide.png"
            },
            {
              name: "Strong Lighting",
              logoSrc: "img/icons/specs/light.png"
            }
          ],
          text: "",
          positionOrder1: "2",
          positionOrder2: "1",
          position: "right"
        },
        {
          id: 2,
          imgSrc: "img/auv/auv/top.png",
          keyImageSrc: "",
          header: "",
          tables: [
            {
              caption: "General Specifications",
              id: 0,
              data: [
                {
                  depthRating: "80 m",
                  autonomous: "yes",
                  objectDetection: "yolov5"
                }
              ]
            },
            {
              caption: "Vehicle Dimensions",
              id: 1,
              data: [
                {
                  length: "75 cm",
                  width: "65 cm",
                  height: "30 cm",
                  weight: "30 KG (in air)"
                }
              ]
            }
          ],
          positionOrder1: "1",
          positionOrder2: "2",
          position: "left"
        },
        {
          id: 3,
          imgSrc: "img/auv/auv/bottom.png",
          table: "Vehicle Dimensions",
          tables: [
            {
              caption: "Propulsion",
              id: 0,
              data: [
                {
                  maximumSpeed: "2 m/s",
                  thruster: "T-200 BlueRobotics thruster",
                  verticalThrust: "4 Thrusters",
                  horizontalThrust: "4 Thrusters"
                }
              ]
            },
            {
              caption: "Lighting",
              id: 1,
              data: [
                {
                  Type: "Led Arrays",
                  Count: "8",
                  Luminous: "8000 Lumens"
                }
              ]
            },
            {
              caption: "Batteries",
              id: 2,
              data: [
                {
                  cellCount: "4",
                  voltage: "14.8 Volts",
                  energy: "325.6 W H",
                  cRating: "20"
                }
              ]
            }
          ],
          text: "",
          positionOrder1: "2",
          positionOrder2: "1",
          position: "right"
        }
      ]
    };
  },
  mounted() {
    document.documentElement.style.scrollBehavior = "smooth";

    // document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    //   anchor.addEventListener("click", function(e) {
    //     e.preventDefault();

    //     var hrefAtt = document.querySelector(this.getAttribute("href"));
    //     if (hrefAtt)
    //       hrefAtt.scrollIntoView({
    //         behavior: "smooth"
    //       });
    //   });
    // });

    window.scrollTo(0, 10);
    this.fadeInElements = Array.from(
      document.getElementsByClassName("fade-in")
    );
    document.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function(e) {
        e.preventDefault();

        var hrefAtt = document.querySelector(this.getAttribute("href"));
        if (hrefAtt)
          hrefAtt.scrollIntoView({
            behavior: "smooth"
          });
      });
    });
    this.filterSelection("All");
    document.getElementById("nav-collapse").style.backgroundColor = "#f2f2f2";
    document.getElementById("n121").style.backgroundColor = "#f2f2f2";
    document.getElementById("n122").style.backgroundColor = "#f2f2f2";
    document.getElementById("n123").style.backgroundColor = "#f2f2f2)";
    document.getElementById("n121").style.color = "rgb(0,0,0) !important";
  },
  methods: {
    onShown() {
      this.$refs.cancel.focus();
    },
    onHidden() {
      this.$refs.show.focus();
    },
    handleScroll(evt) {
      for (var i = 0; i < this.fadeInElements.length; i++) {
        var elem = this.fadeInElements[i];
        if (this.isElemVisible(elem)) {
          elem.style.opacity = "1";
          elem.style.transform = "scale(1)";
          //this.fadeInElements.splice(i, 1); // only allow it to run once
        } else {
          elem.style.opacity = "0";
          //elem.style.transform = "scale(0)";
        }
      }
    },
    isElemVisible(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top + 150; // 200 = buffer
      var elemBottom = rect.bottom;
      return elemTop < window.innerHeight && elemBottom >= 0;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    youClicked() {
      window.scrollBy(0, 900);
    },
    w3AddClass(element, name) {
      var i, arr1, arr2;
      arr1 = element.className.split(" ");
      arr2 = name.split(" ");
      for (i = 0; i < arr2.length; i++) {
        if (arr1.indexOf(arr2[i]) == -1) {
          element.className += " " + arr2[i];
        }
      }
    },
    w3RemoveClass(element, name) {
      var i, arr1, arr2;
      arr1 = element.className.split(" ");
      arr2 = name.split(" ");
      for (i = 0; i < arr2.length; i++) {
        while (arr1.indexOf(arr2[i]) > -1) {
          arr1.splice(arr1.indexOf(arr2[i]), 1);
        }
      }
      element.className = arr1.join(" ");
    }
  }
};
</script>
